import React from 'react'
import { prefix } from '../normalizer'

const tRegister = prefix('gamification2026.register')

const TermsAndConditionsForm = ({ termsAccepted, onTermsCheckChange, onShowTerms }) => {

  const handleTermsCheckChange = e => {
    onTermsCheckChange(e.target.checked)
  }

  const handleShowTerms = e => {
    e.preventDefault()
    onShowTerms()
  }

  return (
    <div className="register__section register__terms">
      <h3 className="register__section-title">{tRegister('terms-title')}</h3>
      <label className="register__terms-checkbox-wrapper">
        <input
          type="checkbox"
          className="register__terms-checkbox"
          checked={!!termsAccepted}
          onChange={handleTermsCheckChange}
        />
        <span className="register__terms-label">
          {tRegister('terms-accept-prefix')}
          <button type="button" className="register__terms-link" onClick={handleShowTerms}>
            {tRegister('terms-link')}
          </button>
          {tRegister('terms-accept-suffix')}
        </span>
      </label>
    </div>
  )
}

export default TermsAndConditionsForm

